import {useQueryParams} from '@aboutyou/router';
import {useRef} from 'react';

import {
  CHECKOUT_URL_PARAMS,
  GRIPS_DEVICE_ANDROID_APP,
  GRIPS_DEVICE_IOS_APP,
} from '../features/Checkout/constants';

export const useDeviceQueryParam = () => {
  const queryParams = useQueryParams();
  // make sure this value never changes after it was set on first mount so that the banner does not pop in when the user navigates
  const deviceParam = useRef(queryParams.get(CHECKOUT_URL_PARAMS.device) || '');

  return [GRIPS_DEVICE_IOS_APP, GRIPS_DEVICE_ANDROID_APP].includes(
    deviceParam.current,
  );
};
